<template>
  <div v-if="product.description.trim().length" class="builder__description" :class="responsiveCssClasses">
    <div class="builder__description-heading">
      <h2>Product Description</h2>
    </div>
    <div class="builder__description-content" v-html="product.description"></div>
  </div>
</template>

<script>
  export default {
    name: 'builder-description',
    props: ['product', 'isWidescreen'],
    data() {
      return {
        responsiveCssClasses: {
          'builder__description--tablet-landscape-and-larger': this.isWidescreen,
          'builder__description--tablet-portrait-and-smaller': !this.isWidescreen,
        },
      }
    },
  }
</script>



// WEBPACK FOOTER //
// Description.vue?45eb0a4d